import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import api, { getApiError } from '../services/api'
import { useAuthStore } from '../stores/authStore'

function LoginPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const setSession = useAuthStore(state => state.setSession)
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)

    try {
      const { data } = await api.post('/auth/login', { email, senha })
      setSession(data)
      toast.success('Login realizado com sucesso!')
      const next = searchParams.get('next')
      navigate(next?.startsWith('/') ? next : '/')
    } catch (error) {
      toast.error(getApiError(error))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-white">
      <img
        src="/brand/agente-de-estudo-icone.svg"
        alt="Agente de Estudo"
        width="48"
        height="48"
        className="mb-6 h-12 w-12"
      />
      <h1 className="text-xl font-medium mb-1">Bem-vindo de volta!</h1>
      <p className="text-sm text-gray-500 mb-8">Entre para continuar seus estudos</p>

      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-3">
        <input
          type="email"
          value={email}
          onChange={event => setEmail(event.target.value)}
          placeholder="E-mail"
          className="input-field"
          autoComplete="email"
          required
        />
        <input
          type="password"
          value={senha}
          onChange={event => setSenha(event.target.value)}
          placeholder="Senha"
          className="input-field"
          autoComplete="current-password"
          required
        />
        <button type="submit" disabled={loading} className="btn-primary w-full py-2.5">
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>

      <p className="text-sm text-gray-500 mt-4">
        Não tem conta?{' '}
        <Link to="/register" className="text-black font-medium underline">Cadastre-se</Link>
      </p>
    </div>
  )
}

export default LoginPage
